import React, { useState } from 'react';
import { FaInfoCircle, FaTrash } from 'react-icons/fa';
import { Button, Table } from 'reactstrap';
import { ProductContainer } from './styled';
import Select from 'react-select';
import { getFlexSelectCustomStyle } from 'assets/styles/multiple_select';
import ProductDetailsModal from './ProductDetailsModal';
import CurrencyMask from 'components/Inputs/CurrencyMask';

export const SelectedProductsTable = ({
  products = [],
  setProducts = () => {},
  selectedProducts = new Set(),
  setSelectedProducts = () => {},
  productsList = [],
  control
}) => {
  const [modal, setModal] = useState(false);
  const [productIdSelectedModal, setProductIdSelectedModal] = useState(null);
  const toggleModal = () => setModal(!modal);

  const handleInfoClick = (productId) => {
    setProductIdSelectedModal(productId);
    toggleModal();
  };

  const getAvailableProducts = (currentIndex) => {
    const actuallySelectedProducts = new Set();

    products.forEach((product, index) => {
      if (index !== currentIndex && product.productId) {
        actuallySelectedProducts.add(product.productId);
      }
    });

    return productsList.filter(
      (product) => !actuallySelectedProducts.has(product.id)
    );
  };

  const handleAddProduct = () => {
    setProducts([
      ...products,
      {
        id: Date.now(),
        productId: null,
        name: '',
        defaultPrice: '',
        catalogPrice: ''
      }
    ]);
  };

  const handleCatalogPriceChange = (index, value) => {
    const newProducts = [...products];
    newProducts[index].catalogPrice = value;
    setProducts(newProducts);
  };

  const handleProductSelect = (index, productId) => {
    const newProducts = [...products];
    const oldProductId = newProducts[index].productId;

    if (oldProductId) {
      const newSelected = new Set(selectedProducts);
      newSelected.delete(oldProductId);
      setSelectedProducts(newSelected);
    }

    if (productId) {
      const selectedProduct = productsList.find(
        (p) => p.id === parseInt(productId)
      );
      if (selectedProduct) {
        setSelectedProducts(new Set([...selectedProducts, selectedProduct.id]));
        newProducts[index] = {
          ...newProducts[index],
          productId: selectedProduct.id,
          name: selectedProduct.name,
          defaultPrice: selectedProduct.basePrice
        };
      }
    } else {
      newProducts[index] = {
        ...newProducts[index],
        productId: null,
        name: '',
        defaultPrice: ''
      };
    }

    setProducts(newProducts);
  };

  const handleRemoveProduct = (index) => {
    const removedProduct = products[index];
    if (removedProduct.productId) {
      const newSelected = new Set(selectedProducts);
      newSelected.delete(removedProduct.productId);
      setSelectedProducts(newSelected);
    }
    setProducts(products.filter((_, idx) => idx !== index));
  };

  const allProductsSelected =
    productsList.length > 0 &&
    products.filter((p) => p.productId).length >= productsList.length;

  return (
    <ProductContainer>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th className="w-50">Produto</th>
            <th className="w-25">Valor Padrão</th>
            <th className="w-25">Valor no Catálogo</th>
            <th className="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center text-muted">
                Nenhum produto adicionado
              </td>
            </tr>
          ) : (
            products.map((product, index) => (
              <tr key={product.id}>
                <td>
                  <Select
                    styles={getFlexSelectCustomStyle({ minHeight: '38px' })}
                    classNamePrefix="react-select"
                    placeholder="Selecione..."
                    value={
                      product.productId
                        ? {
                            label: product.name,
                            value: product.productId
                          }
                        : null
                    }
                    closeMenuOnSelect={true}
                    noOptionsMessage={() => 'Nenhuma opção'}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onChange={
                      control
                        ? (selectedOption) =>
                            handleProductSelect(index, selectedOption?.value)
                        : (selectedOption) =>
                            handleProductSelect(index, selectedOption?.value)
                    }
                    options={
                      control
                        ? getAvailableProducts(index).map((product) => ({
                            label: product.name,
                            value: product.id
                          }))
                        : getAvailableProducts(index).map((product) => ({
                            label: product.name,
                            value: product.id
                          }))
                    }
                  />
                </td>
                <td>
                  <CurrencyMask
                    valueController={(_fieldName, value) => {
                      const newProducts = [...products];
                      newProducts[index].defaultPrice = value;
                      setProducts(newProducts);
                    }}
                    fieldName={`product_${index}_defaultPrice`}
                    value={product.defaultPrice}
                    shouldDisable={true}
                  />
                </td>
                <td>
                  <CurrencyMask
                    valueController={(_fieldName, value) =>
                      handleCatalogPriceChange(index, value)
                    }
                    fieldName={`product_${index}_catalogPrice`}
                    value={product.catalogPrice}
                  />
                </td>
                <td className="text-center">
                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      size="sm"
                      color="info"
                      onClick={() => handleInfoClick(product.productId)}
                      disabled={!product.productId}
                    >
                      <FaInfoCircle />
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => handleRemoveProduct(index)}
                    >
                      <FaTrash />
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Button
        onClick={handleAddProduct}
        color="primary"
        size="sm"
        style={{ width: '100px' }}
        disabled={allProductsSelected}
      >
        Adicionar Produto
      </Button>
      <ProductDetailsModal
        isModalOpen={modal}
        onModalToggle={setModal}
        productId={productIdSelectedModal}
      />
    </ProductContainer>
  );
};
